/**
 * @file editAnnotation.saga.js
 * @description
 *
 * @copyright veriome labs, llc.  - all rights reserved.
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.md', which is part of this source code package.
 *
 * @author don michael
 * @since Feb 09, 2023 06:45
 */
import { call, put, takeLatest } from 'redux-saga/effects';
import axiosClient from 'src/services/axiosClient.js';

import {
    ANNOTATION_EDITOR_EDIT_ANNOTATION_REQUEST,
    editAnnotationSuccess,
    editAnnotationFailure,
} from 'src/store/actions/annotationEditor.actions';

import { dataLoadingSet } from 'src/store/actions/global.actions';

import handleSagaErrors from 'src/store/sagas/handleSagaErrors';

function callApi(payload) {
    const url = '/annotationEditor/editAnnotation';

    const baseUrl = import.meta.env.VITE_APP_API_BASE_URL;

    const config = {
        method: 'post',
        baseURL: baseUrl,
        url,
        data: {
            annotationId: payload,
        },
    };

    return new Promise((resolve, reject) => {
        axiosClient(config)
            .then((response) => {
                resolve(response.data);
            })
            .catch((err) => {
                reject(err);
            });
    });
}

function* requestSaga(action) {

    try {
        yield put(dataLoadingSet(true));

        const resp = yield call(callApi, action.payload);

        yield put(dataLoadingSet(false));
        yield put(editAnnotationSuccess(resp.payload));

    } catch (error) {
        yield put(editAnnotationFailure(error));
        handleSagaErrors(error);

    } finally {
        yield put(dataLoadingSet(false));
    }

}

export default function* requestMonitor() {
    yield takeLatest(ANNOTATION_EDITOR_EDIT_ANNOTATION_REQUEST, requestSaga);
}
